import DOMPurify from 'dompurify';

export function removeHtmlFromText(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
}

export function sanitizeSubtitles(html: string): string {
  try {
    // sanitize the content to prevent XSS attacks
    // and replace new lines with <br> tags
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: ['br', 'b', 'i', 'u', 'strong', 'em', 'span'],
      ALLOWED_ATTR: ['style'],
    }).replace(/\n/g, '<br> \n');
  } catch {
    // If DOMPurify fails, we return an empty string to avoid breaking the app
    return '';
  }
}
